import React, { useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa';

interface FormData {
  name: string;
  email: string;
  phoneNumber: string;
  acceptTerms: boolean;
}

interface UserFormProps {
  handleBack: () => void;
  handleSubmit: (formData: FormData) => void;
  isLoading: boolean;
}

const FormFilling: React.FC<UserFormProps> = ({ handleBack, handleSubmit, isLoading }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [acceptTerms, setAcceptTerms] = useState(false);

  const isValidEmail = (email:string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isFormValid = () => {
    return name !== '' && isValidEmail(email) &&  acceptTerms;
  };

  const onFormSubmit = () => {
    const formData: FormData = {
      name,
      email,
      phoneNumber,
      acceptTerms
    };
    handleSubmit(formData);
  };
  return (
    <div className="mt-4 p-4 bg-white shadow-md rounded-lg">
      <div className="flex items-center mb-4">
        <button className="bg-gray-500 hover:bg-gray-700 font-bold py-2 px-4 rounded" onClick={handleBack}>
          <FaArrowLeft className="mr-2" />
        </button>
      </div>
      <div className="mb-4">
                  <label className="block mb-2 text-sm font-bold text-gray-700">Name *:</label>
                  <input type="text"  value={name} onChange={(e) => setName(e.target.value)}  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
        </div>
                <div className="mb-4">
                  <label className="block mb-2 text-sm font-bold text-gray-700">Email *:</label>
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                </div>
                <div className="mb-4">
                  <label className="block mb-2 text-sm font-bold text-gray-700">Phone Number :</label>
                  <input type="tel" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)}  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                </div>
                <div className="mb-4">
                  <label className="inline-flex items-center">
                    <input type="checkbox" checked={acceptTerms} onChange={(e) => setAcceptTerms(e.target.checked)}  className="form-checkbox" />
                    <span className="ml-2">Accept Terms and Conditions</span>
                  </label>
                </div>
                <button
        className={`bg-blue-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline ${
          !isFormValid() || isLoading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-700'
        }`}
        type="button"
        onClick={onFormSubmit}
        disabled={!isFormValid() || isLoading}
      >
        {isLoading ? 'Loading...' : 'Submit'}
      </button>
    </div>
  );
};

export default FormFilling;
